var PassengerFormSsrs = (function ($) {

    PassengerFormSsrs = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options['$wrapper'];

        // OPTIONS
        that.modals = options['modals'];
        that.departure_date = options['departure_date'];
        that.onConfirm = options['onConfirm'] || function () {};
        that.getSsrs = options['getSsrs'] || function () { return []; };

        // INPUTS

        // CONST
        that.ssr_select = {
            content: '.js-ssr-mobile-content',
            ssr_field: '.js-ssr-field',
            checkbox_need_visual: '.js-ssr-need-visual',
            checkbox_need_hear: '.js-ssr-need-hear',
            checkbox_need_wheelchair: '.js-ssr-need-wheelchair',
            alert_need_hear: '.js-ssr-need-hear-alert',
            radiogroup_need_wheelchair_options: '.js-wheelchair-options',
            radio_need_wheelchair_airplane: '.js-wheelchair-airplane',
            radio_need_wheelchair_trap: '.js-wheelchair-trap',
            radio_need_wheelchair_seat: '.js-wheelchair-seat'
        };

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    PassengerFormSsrs.prototype.init = function () {
        var that = this;

        //
        that.__init();
    };

    PassengerFormSsrs.prototype.render = function () {
        var that = this;

        //
        that.__render();
    };

    PassengerFormSsrs.prototype.reset = function () {
        var that = this;

        // говорим, что сохраняем пустые значения
        that.onConfirm([]);
    };

    PassengerFormSsrs.prototype.getSsrClassName = function () {
        var that = this;

        return that.ssr_select.ssr_field;
    }

    PassengerFormSsrs.prototype.__init = function () {
        var that = this;

        // Если мы считываем из localStorage менее 24 часов до вылета
        if (!that.__isAllowed()) {
            setTimeout(function () {
                that.reset();
            }, 50);
        }
    };

    PassengerFormSsrs.prototype.__render = function () {
        var that = this;

        if (that.__isAllowed()) {
            that.__renderModal();
        } else {
            that.__renderNotAllowedModal();
        }
    };

    PassengerFormSsrs.prototype.__renderNotAllowedModal = function () {
        var that = this,
            $wrapper = $(that.modals['ssrs_not_available']).clone();

        $.uiModal({
            $wrapper: $wrapper
        });
    };

    PassengerFormSsrs.prototype.__renderModal = function () {
        var that = this,
            $wrapper = $(that.modals['ssrs']).clone();

        $.uiModal({
            mobile_fullscreen: true,
            $wrapper: $wrapper,
            onOpen: function ($modal, modal) {
                that.__makeInputSSR($modal);
                that.__initSSRTemplate($modal);

                // Хак для iOS. Некорректно ресайзит окно при открывании аккордеона (изменении высоты)
                let change_timer = 0,
                    animate_time = 500;

                $modal.on('change', function() {
                    clearTimeout(change_timer);
                    change_timer = setTimeout( function() {
                        modal.resize();
                    }, animate_time)
                });
            },
            onButtonConfirmClick: function (modal, event) {
                var $form = modal.$modal_body.find('form');

                if ($form) {
                    that.onConfirm($form.serializeArray());
                }
            },
        });
    };

    PassengerFormSsrs.prototype.__makeInputSSR = function ($modal) {
        var that = this,
            ssrs = that.getSsrs(),
            $inputs = $modal.find(that.ssr_select.ssr_field);

        $inputs.each(function () {
            var $input = $(this),
                attr_value = $input.attr('value');

            // подстановка значений в поля формы
            var has_ssr = ssrs.find(function (input_data) { return input_data.value === attr_value; });

            if (has_ssr) {
                $input.prop('checked', true);
            }
        });
    }

    PassengerFormSsrs.prototype.__initSSRTemplate = function ($modal) {
        var that = this,
            $need_visual = $modal.find(that.ssr_select.checkbox_need_visual),
            $need_hear = $modal.find(that.ssr_select.checkbox_need_hear),
            $need_wheelchair = $modal.find(that.ssr_select.checkbox_need_wheelchair),
            $need_hear_alert = $modal.find(that.ssr_select.alert_need_hear),
            $need_wheelchair_options = $modal.find(that.ssr_select.radiogroup_need_wheelchair_options),
            $need_wheelchair_airplane = $modal.find(that.ssr_select.radio_need_wheelchair_airplane),
            $need_wheelchair_trap = $modal.find(that.ssr_select.radio_need_wheelchair_trap),
            $need_wheelchair_seat = $modal.find(that.ssr_select.radio_need_wheelchair_seat);

        function update_alert (checked_visual, checked_hear) {
            $need_hear_alert[checked_visual && checked_hear ? 'slideDown' : 'slideUp'](400);
        }

        function update_need_visual () {
            var checked_visual = $need_visual.prop('checked'),
                checked_hear = $need_hear.prop('checked'),
                $card = $need_visual.closest('.card');

            $card[checked_visual ? 'addClass' : 'removeClass']('grape');

            update_alert(checked_visual, checked_hear);
        }

        function update_need_hear () {
            var checked_visual = $need_visual.prop('checked'),
                checked_hear = $need_hear.prop('checked'),
                $card = $need_hear.closest('.card');

            $card[checked_hear ? 'addClass' : 'removeClass']('grape');

            update_alert(checked_visual, checked_hear);
        }

        function update_need_wheelchair () {
            var checked = $need_wheelchair.prop('checked'),
                $card = $need_wheelchair.closest('.card');

            $card[checked ? 'addClass' : 'removeClass']('grape');

            $need_wheelchair_options[checked ? 'slideDown' : 'slideUp'](400);

            if (!checked) {
                $need_wheelchair_airplane.prop('checked', false);
                $need_wheelchair_trap.prop('checked', false);
                $need_wheelchair_seat.prop('checked', false);
            }
        }

        update_need_visual();
        update_need_hear();

        if ($need_wheelchair_airplane.prop('checked') ||
            $need_wheelchair_trap.prop('checked') ||
            $need_wheelchair_seat.prop('checked')) {
            $need_wheelchair.prop('checked', true);
            update_need_wheelchair();
        }

        $need_visual.on('change', update_need_visual);
        $need_hear.on('change', update_need_hear);
        $need_wheelchair.on('change', update_need_wheelchair);
    };

    PassengerFormSsrs.prototype.__isAllowed = function () {
        var that = this,
            departure_date_formatted = dayjs(that.departure_date, 'YYYY-MM-DD HH:mm:ss'),
            hours = departure_date_formatted.diff(dayjs($.sa.server_datetime, 'YYYY-MM-DD HH:mm:ss'), 'hours');

        return hours > 24;
    };

    return PassengerFormSsrs;

})($);
